<div class="relative @container">
  <app-dtc-selection-table
    [dtcs]="items"
    [errorMessageId]="errorMessageId"
    [isReadOnly]="dtcSelectionTableReadOnly"
    (scrolledToBottom)="onScrolledToTheBottom($event)"
    (searchTriggered)="onSearchTriggered($event)"
    (sortByFieldChanged)="onSortByChanged($event)"
    (selectedDtcsChanged)="onUpdateSelection($event)"
  ></app-dtc-selection-table>
  <button
    [appEnabledByPolicy]="policy.canUpdateBasic"
    [disabled]="swPartNumberIsReadOnly"
    (click)="checkUpdateLinkedDtcs()"
    class="crud-btn-sidebar bottom-10 right-0"
    appAgentAction
    agent="dtc-selection-overview-save"
    businessObject="errorMessage"
    [businessId]="errorMessageId"
    action="save"
  >
    <app-floppy-icon></app-floppy-icon>
  </button>
</div>
<app-decision-modal
  #anotherErrorMessageDecisionModal
  (decision)="decisionToUpdateLinkedDtcs($event)"
  [entityId]="errorMessageId"
  businessObject="errorMessage"
  [header]="'DTC(s) already assigned to another Error Message'"
  [details]="
    ['The following DTC(s) are already assigned to another Error Message. Would you like to continue?'].concat(
      dtcsAssignedToAnotherErrorMessages || []
    )
  "
></app-decision-modal>
<app-propagate-linked-dtcs-modal
  #propagateLinkedDtcsModal
  (changesConfirmed)="onLinkedDtcsPropagationConfirmed($event)"
  (notPropagateChanges)="onLinkedDtcsPropagationSkipped()"
></app-propagate-linked-dtcs-modal>
